import { render, staticRenderFns } from "./OfficeProducts.vue?vue&type=template&id=8861fa28&"
import script from "./OfficeProducts.vue?vue&type=script&lang=js&"
export * from "./OfficeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports